import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';

import { WizardStepsComponent } from './wizard-steps.component';

@NgModule({
	imports: [CommonModule, CwpNgFrameworkModule],
	declarations: [WizardStepsComponent],
	exports: [WizardStepsComponent]
})
export class WizardStepsModule { }
